import React, { useRef, useState } from 'react';
import { Box } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";

function Arrow({ direction, onClick }) {
  const isPrevious = direction === 'previous';
  return (
    <button
      type="button"
      aria-label={isPrevious ? 'Imagem anterior' : 'Próxima imagem'}
      className={`carousel-arrow carousel-arrow-${direction}`}
      onClick={onClick}
    >
      {isPrevious ? <ChevronLeftIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
    </button>
  );
}

export default function ImageCarousel({ images, alt = "Imagem do produto" }) {
  const sliderRef = useRef(null);
  const fallbackImage = "/nofigure.png";
  const [activeSlide, setActiveSlide] = useState(0);

  const availableImages = (images ?? []).filter(image =>
    image.url_ds && !image.url_ds.toLowerCase().includes('nofigure')
  );
  const largeImages = availableImages.filter(image =>
    image.url_ds.split('/').some(part =>
      ['extralarge', 'large', 'big'].includes(part.toLowerCase())
    )
  );
  const validImages = largeImages.length > 0 ? largeImages : availableImages;

  if (validImages.length === 0) return null;

  const hasMultiple = validImages.length > 1;

  const settings = {
    dots: false,
    arrows: hasMultiple,
    infinite: hasMultiple,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <Arrow direction="previous" />,
    nextArrow: <Arrow direction="next" />,
    beforeChange: (_current, next) => setActiveSlide(next),
  };

  return (
    <Box sx={{ width: 400 }}>
      <Box sx={{
        position: "relative",
        '& .carousel-arrow': {
          alignItems: "center",
          backgroundColor: "rgba(0, 34, 51, 0.9)",
          border: 0,
          borderRadius: "50%",
          color: "#fff",
          cursor: "pointer",
          display: "flex",
          height: 40,
          justifyContent: "center",
          padding: 0,
          position: "absolute",
          top: "50%",
          transform: "translateY(-50%)",
          width: 40,
          zIndex: 2,
          "&:hover": { backgroundColor: "#002233" },
        },
        '& .carousel-arrow-previous': { left: 8 },
        '& .carousel-arrow-next': { right: 8 },
      }}>
        <Slider ref={sliderRef} {...settings}>
          {validImages.map(image => (
            <div key={image.url_ds}>
              <img src={image.url_ds} alt={alt} onError={event => {
                if (event.currentTarget.src.endsWith(fallbackImage)) return;
                event.currentTarget.src = fallbackImage;
              }} style={{ height: "280px", maxWidth: "100%", objectFit: "contain", margin: "auto", display: "block" }} />
            </div>
          ))}
        </Slider>
      </Box>

      {hasMultiple && (
        <Box sx={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: "12px" }}>
          {validImages.map((image, index) => (
            <button
              key={image.url_ds}
              type="button"
              aria-label={`Ir para imagem ${index + 1}`}
              onClick={() => sliderRef.current?.slickGoTo(index)}
              style={{
                width: 11,
                height: 11,
                borderRadius: "50%",
                border: 0,
                padding: 0,
                cursor: "pointer",
                backgroundColor: index === activeSlide ? "#002233" : "#BBBFC6",
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
}